import { zodResolver } from "@mantine/form";
import { patientWeightSchema } from "beitary-shared";
import { z } from "zod";

const patientWeightFormSchema = patientWeightSchema.omit({ id: true, a: true });

export type PatientWeightFormValues = z.infer<typeof patientWeightFormSchema>;

export const rules = zodResolver(patientWeightFormSchema);
